import MainComponent from "./component/MainComponent/MainComponent";
import 'bootstrap/dist/css/bootstrap.min.css';
import Editprofile from "./component/Pages/Editprofile";
import { GoogleOAuthProvider } from "@react-oauth/google";
import UserContextProvider from "./Context";
import CustomThemeProvider from "./theme/ThemeProvider";
import './font.css';


function App() {
  return (
    <CustomThemeProvider>
      <div style={{ fontFamily: 'Inter, sans-serif' }}>
        <GoogleOAuthProvider>
          <UserContextProvider>
            <MainComponent style={{ fontFamily: 'Inter, sans-serif' }} />
          </UserContextProvider>
        </GoogleOAuthProvider>
      </div>
    </CustomThemeProvider>
  );
}

export default App;
